import PreviousCounter from 'utilities/PreviousCounter';


//{['Journey', 'Occurrences', 'Name', 'Action', 'Delta', 'Sequence', 'Steps away', 'Timestamp', 'Software Version', 'Device Model', 'Operating System Version', 'Category', 'Result', 'UUIDs', 'Tags', 'Detail', 'Identifier', 'Load Time', 'Price']}
//
export default function JourneyCsvData(onOutcomeCsv, name, uuid, uuidToOutcomeName) {
    return async () => {
        let journeys = await onOutcomeCsv({name: name, uuid: uuid});
        const piecesOfName = name.split(':');
        let csvData = [];
        journeys.forEach((journey) => {
            const {title, occurrences, series, extra, steps, links, tags} = journey;
            const platform = extra ? extra.platform : {softwareVersion:'', deviceModel:'', operatingSystemVersion:''};
            const {softwareVersion, deviceModel, operatingSystemVersion} = platform;

            const journeyCategory = piecesOfName.length > 1 ? piecesOfName[0] : '';
            const result = piecesOfName.length > 1 ? piecesOfName[1] : '';
            const name = piecesOfName[piecesOfName.length-1];
            const topTimestamp = series.at(-1);
            const formattedTags = formatTags(tags);

            let totalSteps = steps.length;
            let previouses = 0;
            let purchase_price = '';
            if (totalSteps > 0) {
                const last = steps[totalSteps-1];
                const {outcome, price} = last;
                if (outcome){
                    totalSteps = totalSteps - 1;
                    purchase_price = price?price:'';
                }
            }

            const data = [title, occurrences, name, '', '', '', '0', topTimestamp, softwareVersion, deviceModel, operatingSystemVersion, journeyCategory, result, links, formattedTags, '', '', '', purchase_price.toString()];
            csvData.push(data);

            steps.forEach((step, sequence) => {
                step.action = (typeof step.action === 'string' || step.action instanceof String) ? step.action.replace(/,/g, '') : step.action; //remove all commas from the action
                const {outcome, delta, category, action, count = 1, previous, timestamp, name, type, identifier, time, price} = step;
                const detail = name ? name : type ? type : '';
                if (outcome) return;
                if (previous) {
                    const counts = PreviousCounter(previous);
                    totalSteps = totalSteps + counts.length - 1;
                    counts.forEach((step, index) => (csvData.push([
                        journey.title,
                        step.count(),
                        uuidToOutcomeName[step.item()],
                        '',
                        '',
                        index,
                        totalSteps-index,
                        timestamp, softwareVersion, deviceModel, operatingSystemVersion, journeyCategory, '',
                        links, formattedTags, detail, (identifier?identifier:''), (time?time.toString():''), (price?price.toString():'')
                    ])));
                    previouses = counts.length-1;
                    return;
                }
                const index = sequence + previouses;
                csvData.push([
                    journey.title,
                    count,
                    category,
                    action,
                    delta > 0 ? delta : 0 ,
                    index,
                    totalSteps-index,
                    timestamp, softwareVersion, deviceModel, operatingSystemVersion, journeyCategory, '',
                    links, formattedTags, detail, (identifier?identifier:''), (time?time.toString():''), (price?price.toString():'')
                ]);
            });
        });
        return csvData;
    };
}

export function formatTags(tags) {
    if (!tags) return tags;
    tags = Object.fromEntries(Object.entries(tags).filter((tag) => {
       return tag[1].length > 0;
    }));

    const keys = Object.keys(tags);

    if (keys.length === 0) {
        return undefined;
    }

    const tags_processed = keys.map(
        (element)=>{
            const items = tags[element];
            return items.filter((item) => {
                return item && !item.toString().includes("BladeHQ-Instrumentation-v");
            });
        }
    )
    const tagsSet = new Set(tags_processed.flat());
    return [...tagsSet].join(';');
}